<template>
  <div class="h-screen grid grid-rows-[auto_1fr] bg-pitch-black">
    <!-- Header -->
    <div
      class="flex w-full justify-between items-center px-4 p-3 border border-x-0 border-t-0 border-b-1 border-prime-golden bg-pitch-black-900"
    >
      <a href="/" class="text-prime-golden font-avenir-medium mb-[-4px]"
        ><img
         class="w-24 h-24 -my-8 -ml-[10px]"

          src="@/assets/images/mason-logo.svg"
          alt="Mason Logo"
      /></a>
      <a href="/login" class="text-prime-golden">Log in</a>
    </div>
    <div class="overflow-y-auto">
      <div
        class="w-full overflow-y-auto flex flex-col justify-start lg:justify-center pb-10 items-start max-w-sm mx-auto px-4"
      >
        <!-- Contact Us Form -->
        <div class="w-full pb-[200px]">
          <h2 class="text-3xl w-fit text-total-white font-bold mt-8 mb-4">Contact us</h2>
          <form @submit.prevent="handleSubmit">
            <!-- First Name -->
            <div>
              <label class="flex justify-start text-total-white p-1" for="firstName"
                >First name</label
              >
              <input
                type="text"
                id="firstName"
                v-model="firstName"
                class="w-full p-3 bg-dark-grey rounded-xl mb-6 text-total-white focus:outline-none focus:border-prime-golden"
              />
            </div>

            <!-- Last Name -->
            <div>
              <label class="flex justify-start text-total-white p-1" for="lastName"
                >Last name</label
              >
              <input
                type="text"
                id="lastName"
                v-model="lastName"
                class="w-full p-3 bg-dark-grey rounded-xl mb-6 text-total-white focus:outline-none focus:border-prime-golden"
              />
            </div>

            <!-- Email -->
            <div>
              <label class="flex justify-start text-total-white p-1" for="email"
                >Email</label
              >
              <input
                type="email"
                v-model="email"
                id="email"
                class="w-full p-3 bg-dark-grey rounded-xl mb-6 text-total-white focus:outline-none focus:border-prime-golden"
              />
            </div>

            <!-- Phone Number with Country Code Picker -->
            <PhoneInput
              id="phone"
              label="Phone number"
              v-model="phone"
              :preferred-countries="['us']"
              default-country="US"
            />

            <!-- Message -->
            <div class="mt-6">
              <label class="flex justify-start text-total-white p-1" for="message"
                >Message</label
              >
              <textarea
                id="message"
                v-model="message"
                class="w-full p-3 bg-dark-grey rounded-xl mb-6 text-total-white focus:outline-none focus:border-prime-golden"
                rows="4"
              ></textarea>
            </div>

            <!-- Send Button -->
            <div>
              <button
                type="submit"
                class="w-full bg-prime-golden text-pitch-black p-2 rounded-full font-semibold"
              >
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useUserStore } from "@/stores/user";
import { useToast } from "vue-toastification";
import PhoneInput from "../components/PhoneInput.vue";

const toast = useToast();

const email = ref("");
const firstName = ref("");
const lastName = ref("");
const phone = ref("");
const message = ref("");

const route = useRoute();
const userStore = useUserStore();

onMounted(() => {
  if (route.query.email) {
    email.value = route.query.email;
  }
});

const handleSubmit = async () => {
  try {
    const contactMessage = {
      first_name: firstName.value,
      last_name: lastName.value,
      email: email.value,
      phone_number: phone.value,
      message: message.value,
    };

    await userStore.submitContactMessage(contactMessage);

    firstName.value = "";
    lastName.value = "";
    email.value = "";
    phone.value = "";
    message.value = "";

    toast.success("Message sent successfully!");
  } catch (error) {
    console.error("Error sending message:", error);
    toast.error(`Failed to send message. ${error.msg}`);
  }
};
</script>
